// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fyBtn[data-v-18d2c466] {\r\n\tmargin-left: 8px;\r\n\twidth: 20px;\r\n\tposition: absolute;\r\n\tcursor: pointer;\n}\n.textareaFyBtn[data-v-18d2c466] {\r\n\twidth: 20px;\r\n\tposition: absolute;\r\n\tcursor: pointer;\r\n\tmargin-left: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
